import withState from "../../../../../../../../utils/withState";
import {apiTerminalsList} from "../../../../../../../../api/merchant/terminals";
import CardTerminals from "../../../CardTerminals";
import TerminalColorDisplay from "../../../TerminalColorDisplay";
import {DisplayDataMerchant, DisplayIdMerchant} from "../../../../../../../dumb/DisplayData";
import upperFirst from "mn-utils/upperFirst";
import {LINK_TERMINALS_DETAILS, LINK_TERMINALS_LIST} from "../../../../../../../../constants/links";
import {getTerminalColor} from "../../../../utils/getTerminalColor";
import React from "react";
import editTerminalName from "../../utils/editTerminalName";
import editNotificationEmail from "../../utils/editNotificationEmail";
import deleteTerminalData from "../../utils/deleteTerminalData";
import Ripple from "../../../../../../../dumb/Ripple";
import {Box, Grid} from "@material-ui/core";


export default withState((setState, self, onMount) => {
  const update = () => {
    setState({loading: true});

    return apiTerminalsList({offset: 0, limit: 100}).then((result) => {
      setState({list: (result || {}).list, loading: false});
    });
  }

  onMount(() => {
    update();
  })

  return (state, props) => {
    if (state.loading) return <span />;

    return state.list.length
      ? (
        <Grid container spacing={1}>
          {(state.list || []).map((el, i) => {
            return (
              <Grid key={i} item xs={12} sm={6} md={4} lg={3}>
                <CardTerminals
                  classNameEffect="list"
                  title={(
                    <div className="layoutRow aiC">
                      <TerminalColorDisplay color={el.color}/>
                      <DisplayDataMerchant className="w100%-40 ml4 pr130 jcFS-i">
                          <span>
                            {el.name || el.device_name}
                          </span>
                      </DisplayDataMerchant>
                    </div>
                  )}
                  stats={[
                    ['Terminal ID', (
                      <DisplayIdMerchant className="ml4">
                        {el.id}
                      </DisplayIdMerchant>
                    )],
                    ['Transactions',
                      el.transaction_count
                    ],
                    ['Status', (
                      <div className={`ml4 c2CE889.active cFFBF43.inactive ` + (el.active ? 'active' : 'inactive') }>
                        {el.active ? 'Active' : 'Inactive' }
                      </div>
                    )]
                  ]}
                  linkProps={{
                    href: LINK_TERMINALS_LIST + `?id=${el.id}`,
                    text: 'Details'
                  }}
                  imgProps={{
                    src: require(`../../assets/terminal--${getTerminalColor(el.color)}.jpg`),
                    title: el.device || el.name
                  }}
                  actionsProps={{
                    id: el.id,
                    itemsList: [
                      {
                        name: 'Edit',
                        onClick: () => editTerminalName(el, update)
                      },
                      {
                        name: 'Notification Email',
                        onClick: () => editNotificationEmail(el, update)
                      },
                      {
                        name: <div className="cE70F0F">Delete</div>,
                        onClick: () => deleteTerminalData(el, update)
                      }
                    ]
                  }}
                />
              </Grid>
            )
          })}
        </Grid>
      ) : (
        <Box height="calc(100vh - 220px)">
          <div className="h layoutRow jcC aiC f16 fw7">
            No active terminals
          </div>
        </Box>
      )
  };
})
